/**
 * Collapsible Properties Inspector Component
 * Wrapper to make PropertiesInspector collapsible like other tools
 */

import React, { useState } from 'react';
import { ChevronDown, ChevronRight, FileText } from 'lucide-react';
import { PropertiesInspector } from './PropertiesInspector';
import { useViewerStore } from '@/store/viewerStore';

export function CollapsiblePropertiesInspector() {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const { isModelLoaded } = useViewerStore();

  return (
    <div className="bg-dark-100 rounded-lg border border-gray-700">
      {/* Header - Always Visible */}
      <button
        onClick={() => setIsCollapsed(!isCollapsed)}
        className="w-full px-4 py-3 flex items-center justify-between hover:bg-dark-200 transition-colors rounded-lg"
      >
        <div className="flex items-center gap-2">
          <FileText className="w-5 h-5 text-cyan-400" />
          <span className="font-semibold text-gray-100">Properties Inspector</span>
          <span className="text-xs text-gray-400"></span>
        </div>
        <div className="flex items-center gap-2">
          {!isCollapsed && (
            <span className="text-xs text-gray-400">
              {isModelLoaded ? '✓ Model Loaded' : '⚠ No Model'}
            </span>
          )}
          {isCollapsed ? (
            <ChevronRight className="w-5 h-5 text-gray-400" />
          ) : (
            <ChevronDown className="w-5 h-5 text-gray-400" />
          )}
        </div>
      </button>

      {/* Collapsible Content */}
      {!isCollapsed && (
        <div className="p-4 border-t border-gray-700 animate-fade-in">
          <PropertiesInspector />
        </div>
      )}
    </div>
  );
}